import { render, staticRenderFns } from "./c-menu.vue?vue&type=template&id=fa0d256c&"
import script from "./c-menu.vue?vue&type=script&lang=js&"
export * from "./c-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports